/**
 * Utilidad para procesamiento de te  // Eliminar listas (* item o - item)
  cleanText = cleanText.replace(/^\s*[*-]\s+/gm, '');o y Markdown
 */

/**
 * Elimina la sintaxis de Markdown de un texto
 * Útil para mostrar extractos limpios en tarjetas y previsualizaciones
 *
 * @param {string} text - Texto con sintaxis Markdown
 * @returns {string} Texto limpio sin sintaxis Markdown
 */
export const stripMarkdown = (text) => {
  if (!text || typeof text !== "string") {
    return "";
  }

  let cleanText = text;

  // Eliminar encabezados (# ## ### etc.)
  cleanText = cleanText.replace(/#{1,6}\s+/g, "");

  // Eliminar negrita y cursiva (**texto** o __texto__)
  cleanText = cleanText.replace(/\*\*(.+?)\*\*/g, "$1");
  cleanText = cleanText.replace(/__(.+?)__/g, "$1");

  // Eliminar cursiva simple (*texto* o _texto_)
  cleanText = cleanText.replace(/\*(.+?)\*/g, "$1");
  cleanText = cleanText.replace(/_(.+?)_/g, "$1");

  // Eliminar enlaces [texto](url)
  cleanText = cleanText.replace(/\[(.+?)\]\(.+?\)/g, "$1");

  // Eliminar imágenes ![alt](url)
  cleanText = cleanText.replace(/!\[.*?\]\(.+?\)/g, "");

  // Eliminar código inline `código`
  cleanText = cleanText.replace(/`(.+?)`/g, "$1");

  // Eliminar bloques de código ```código```
  cleanText = cleanText.replace(/```[\s\S]*?```/g, "");

  // Eliminar listas (* item o - item)
  cleanText = cleanText.replace(/^\s*[*-]\s+/gm, "");

  // Eliminar listas numeradas (1. item)
  cleanText = cleanText.replace(/^\s*\d+\.\s+/gm, "");

  // Eliminar citas (> texto)
  cleanText = cleanText.replace(/^\s*>\s+/gm, "");

  // Eliminar líneas horizontales (--- o ***)
  cleanText = cleanText.replace(/^\s*[-*_]{3,}\s*$/gm, "");

  // Limpiar saltos de línea múltiples
  cleanText = cleanText.replace(/\n{3,}/g, "\n\n");

  // Limpiar espacios múltiples
  cleanText = cleanText.replace(/\s{2,}/g, " ");

  return cleanText.trim();
};

/**
 * Trunca un texto a una longitud específica y agrega puntos suspensivos
 *
 * @param {string} text - Texto a truncar
 * @param {number} maxLength - Longitud máxima
 * @returns {string} Texto truncado
 */
export const truncateText = (text, maxLength = 150) => {
  if (!text || typeof text !== "string") {
    return "";
  }

  if (text.length <= maxLength) {
    return text;
  }

  return text.substring(0, maxLength).trim() + "...";
};
